// System
//
// Reflex game system. Handles events such as resize and game ready.
// Register for callbacks on these events using this:
//
// Reflex.registerEventHandler(event, callback)
//
// Also contains the main game loop. Add any update functions into here.

Reflex = {};
Reflex.EventCallbacks = {
  resize: [],
  devicePerformance: [],
  orientationChange: [],
  load: [],
  ready: [],
  focus: [],
  blur: [],
  fullScreen: [],
  layoutChange: [],
  rendererChanged: [],
  languageChanged: [],
  gameSpeedChanged: [],
};
Reflex.ManagersInitialiseCallbacks = [];
Reflex.developerMode = false;
Reflex.developerModeData = {
  fastSpin: false,
  disableReelLandSound: false,
  showButtonHitAreas: false,
  highlightTranslatedText: false,
  speedModifier: 1.0,
  useLogFiles: false,
  logFileIP: "localhost",
  manipulateCredit: false,
  keyDownCallbacks: [],
  keyUpCallbacks: [],
  forceCanvasRenderer: false,
  canBreakInjectorRules: false,
  createTestLanguages: false,
  singleFrameMovies: false,
  checkUnusuedResources: false,
};
Reflex.showPerformance = false;
Reflex.antiAlias = true;
Reflex.singleRender = false;
Reflex.gamePaused = false;
Reflex.platformPaused = false;
Reflex.updateFunctions = [];
Reflex.stats = undefined;
Reflex.performance = {
  showPerformanceStats: false,
  updateTime: 0,
  updateRequired: false,
};
Reflex.rendererCreated = false;
Reflex.PIXI_MAJOR_VERSION = Number(
  PIXI.VERSION.substring(0, PIXI.VERSION.indexOf("."))
);
Reflex.allowMasks = true;
Reflex.keyStates = {};
Reflex.devicePerformance = {
  measuringCapability: true,
  measuringGame: false,
  capability: { time: 0, frames: 0, value: 1 },
  game: { time: 0, frames: 0, value: 1 },
};

// System data is used for storing system wide parameters / objects
systemData = {};
systemData.canFullScreen = false;
systemData.isFullScreen = false;
systemData.PHYSICAL_SCREEN_WIDTH = 1;
systemData.PHYSICAL_SCREEN_HEIGHT = 1;
systemData.LOGICAL_SCREEN_WIDTH = 1;
systemData.LOGICAL_SCREEN_HEIGHT = 1;
systemData.platform = navigator.platform;
systemData.lastUpdateTime = 0;
systemData.unscaledDelta = 0;
systemData.gameTime = 0;
systemData.isLandscape = gdk.getScreenWidth() >= gdk.getScreenHeight();
systemData.timeScaler = 1.0;
Reflex.syncTimeRequired = false;

Reflex.setLogicalCoordinates = function (width, height) {
  systemData.LOGICAL_SCREEN_WIDTH = width;
  systemData.LOGICAL_SCREEN_HEIGHT = height;
};

Reflex.calculateDevicePerformance = function (calculateCapability) {
  var performanceObject = calculateCapability
    ? Reflex.devicePerformance.capability
    : Reflex.devicePerformance.game;
  var averageFPS = performanceObject.frames / performanceObject.time;

  if (averageFPS >= 60) {
    performanceObject.value = 100;
  } else if (averageFPS <= 1) {
    performanceObject.value = 1;
  } else {
    performanceObject.value = Math.floor(100 * (averageFPS / 60));
  }
};

Reflex.getDevicePerformance = function (capability) {
  if (checkForUndefined(capability)) capability = false;
  var performanceObject = capability
    ? Reflex.devicePerformance.capability
    : Reflex.devicePerformance.game;
  return performanceObject.value;
};

Reflex.checkUnusedResources = function () {
  if (Reflex.developerModeData.checkUnusuedResources) {
    // Check for unusued resources.
    soundManager.checkUnusedResources();
    gdk.checkUnusuedResources();
  }
};

Reflex.enableDeveloperMode = function () {
  if (!gdk.isDevelopmentBuild()) return;
  Reflex.developerMode = true;

  // Register end of game for checking unused resources
  messageBus.subscribe("common:GameCompleteEvent", Reflex.checkUnusedResources);

  resourceManager.configValues.developerModeActive = true;

  // Speed modifier input callback
  Reflex.developerModeData.keyDownCallbacks.push(function (keycode) {
    if (Reflex.developerModeData.manipulateCredit) {
      switch (keycode) {
        case 96: // Keypad 0
        case 97: // Keypad 1
        case 98: // Keypad 2
        case 99: // Keypad 3
        case 100: // Keypad 4
        case 101: // Keypad 5
        case 102: // Keypad 6
        case 103: // Keypad 7
        case 104: // Keypad 8
        case 105: {
          // Keypad 9
          gdk.serverParser.setBalance(
            gameData.creditMeter.Props.currentValue * 10 + (keycode - 96)
          );
          break;
        }
        case 106: {
          // * key
          gdk.serverParser.setBalance(
            gameData.creditMeter.Props.currentValue * 10
          );
          break;
        }
        case 111: {
          // / Key
          var newValue = gameData.creditMeter.Props.currentValue / 10;
          if (newValue < 1) {
            newValue = 0;
          }
          gdk.serverParser.setBalance(newValue);
          break;
        }
        default:
          break;
      }
    } else {
      switch (keycode) {
        case 19: {
          // Pause/break key
          Reflex.gamePaused = !Reflex.gamePaused;
          break;
        }
        case 96: {
          // Keypad 0
          Reflex.gamePaused = !Reflex.gamePaused;
          break;
        }
        case 97: {
          // Keypad 1
          Reflex.developerModeData.speedModifier = 0.0625;
          break;
        }
        case 98: {
          // Keypad 2
          Reflex.developerModeData.speedModifier = 0.125;
          break;
        }
        case 99: {
          // Keypad 3
          Reflex.developerModeData.speedModifier = 0.25;
          break;
        }
        case 100: {
          // Keypad 4
          Reflex.developerModeData.speedModifier = 0.5;
          break;
        }
        case 101: {
          // Keypad 5
          Reflex.developerModeData.speedModifier = 1.0;
          break;
        }
        case 102: {
          // Keypad 6
          Reflex.developerModeData.speedModifier = 2.0;
          break;
        }
        case 103: {
          // Keypad 7
          Reflex.developerModeData.speedModifier = 4.0;
          break;
        }
        case 104: {
          // Keypad 8
          Reflex.developerModeData.speedModifier = 8.0;
          break;
        }
        case 105: {
          // Keypad 9
          Reflex.developerModeData.speedModifier = 16.0;
          break;
        }
        case 106: {
          // * key
          Reflex.developerModeData.speedModifier += 0.05;
          break;
        }
        case 111: {
          // / Key
          Reflex.developerModeData.speedModifier -= 0.05;
          break;
        }
        default:
          break;
      }

      if (Reflex.developerModeData.speedModifier > 256)
        Reflex.developerModeData.speedModifier = 256;
      if (Reflex.developerModeData.speedModifier < 0.00390625)
        Reflex.developerModeData.speedModifier = 0.00390625;

      if (Reflex.gamePaused || Reflex.platformPaused) {
        soundManager.pauseAllSounds();
      } else {
        soundManager.resumeAllSounds();
      }
      soundManager.setTimeScale(Reflex.developerModeData.speedModifier);
      PIXI.ticker.shared.speed = Reflex.developerModeData.speedModifier;
    }
  });
  // Language input callback
  Reflex.developerModeData.keyDownCallbacks.push(function (keycode) {
    var languages = gdk.getAvailableLanguages();
    var currentIndex = languages.indexOf(gdk.getCurrentLanguage());

    switch (keycode) {
      case 33: {
        // Page Up
        if (currentIndex >= languages.length - 1) {
          gdk.setCurrentLanguage(languages[0]);
        } else {
          gdk.setCurrentLanguage(languages[++currentIndex]);
        }
        break;
      }
      case 34: {
        // Page Down
        if (currentIndex <= 0) {
          gdk.setCurrentLanguage(languages[languages.length - 1]);
        } else {
          gdk.setCurrentLanguage(languages[--currentIndex]);
        }
        break;
      }

      case 35: {
        // end
        gdk.saveLanguageDataToFile();
        break;
      }
      default:
        break;
    }
  });
};

Reflex.logMessage = function (severity, message) {
  if (!Reflex.developerModeData.useLogFiles) return;

  var formData = new FormData();
  formData.append("browser", gdk.deviceInfo.name);
  formData.append("gameName", gameData.gameName);
  formData.append("severity", severity);
  formData.append("message", message);

  var request = new XMLHttpRequest();
  var url =
    "http://" + Reflex.developerModeData.logFileIP + "/Logging/LogMessage.php";

  request.open("POST", url);
  request.send(formData);
};

Reflex.onKeyDown = function (event) {
  // event.repeat doesnt work,so do this manually
  if (Reflex.keyStates[event.keyCode] === true) {
    return;
  }
  Reflex.keyStates[event.keyCode] = true;

  // Tell all buttons key had been pressed
  for (var i = 0; i < standardObjectFactory.buttons.length; i++) {
    if (typeof standardObjectFactory.buttons[i].onKeyPressed === "function") {
      standardObjectFactory.buttons[i].onKeyPressed(event.keyCode);
    }
  }

  if (Reflex.developerMode) {
    // Update developer key callbacks
    for (var i = 0; i < Reflex.developerModeData.keyDownCallbacks.length; ++i) {
      Reflex.developerModeData.keyDownCallbacks[i](event.keyCode);
    }
  }
};

Reflex.onKeyUp = function (event) {
  Reflex.keyStates[event.keyCode] = false;

  // Tell all buttons key had been released
  for (var i = 0; i < standardObjectFactory.buttons.length; i++) {
    if (typeof standardObjectFactory.buttons[i].onKeyReleased === "function") {
      standardObjectFactory.buttons[i].onKeyReleased(event.keyCode);
    }
  }

  if (Reflex.developerMode) {
    // Update developer key callbacks
    for (var i = 0; i < Reflex.developerModeData.keyUpCallbacks.length; ++i) {
      Reflex.developerModeData.keyUpCallbacks[i](event.keyCode);
    }
  }
};

Reflex.onFocus = function () {
  /*
    Reflex.gamePaused = false;
    */
  Reflex.keyStates = {};

  if (gdk.deviceInfo && gdk.deviceInfo.safari) {
    // If we have just gained focus, recreate renderer. Safari doesnt play nice.
    Reflex.createRenderer();
    systemData.timeUntilOnResize = systemData.checkSizeInterval;

    // Because we have recreated the renderer, we need to update the viewport to resize the renderer
    Reflex.updateViewport();
  }

  for (var i = 0; i < Reflex.EventCallbacks.focus.length; i++) {
    Reflex.EventCallbacks.focus[i]();
  }

  Reflex.syncTimeRequired = true;
};

Reflex.onBlur = function () {
  /*
	if (gdk.deviceInfo.mobile){
		Reflex.gamePaused = true;
	}
	*/

  for (var i = 0; i < Reflex.EventCallbacks.blur.length; i++) {
    Reflex.EventCallbacks.blur[i]();
  }
};

Reflex.setLanguage = function (code) {
  // Set language. Panel updates will be triggered by gdk message
  gdk.setCurrentLanguage(code);
};

Reflex.onLanguageChanged = function () {
  // First see if we need to add developer languages
  if (Reflex.developerModeData.createTestLanguages) {
    Reflex.developerModeData.createTestLanguages = false;
    if (gdk.availableLanguages.indexOf("X") === -1) {
      // Create two test languages, one with an X and one with wide string
      var testData = [
        "X",
        "WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW",
      ];
      var defaultLang = gdk.availableLanguages[0];
      var translationKeys = Object.keys(gdk.languageData[defaultLang]);
      for (var i = 0; i < testData.length; i++) {
        var newLang = {};
        for (var j = 0; j < translationKeys.length; j++) {
          newLang[translationKeys[j]] = testData[i];
        }
        var languageName = "Test" + (i + 1);
        gdk.languageData[languageName] = newLang;
        gdk.availableLanguages.push(languageName);
      }
    }
  }
  // Tell each text panel to update
  for (var i = 0; i < standardObjectFactory.translatableObjects.length; i++) {
    standardObjectFactory.translatableObjects[i].updateTranslationText();
  }

  // Now do callbacks
  for (var i = 0; i < Reflex.EventCallbacks.languageChanged.length; i++) {
    Reflex.EventCallbacks.languageChanged[i]();
  }
};

Reflex.setGameSpeed = function (speed) {
  systemData.timeScaler = speed;

  var newspeed = systemData.timeScaler;
  if (Reflex.developerMode) newspeed *= Reflex.developerModeData.speedModifier;

  soundManager.setTimeScale(newspeed);
  PIXI.ticker.shared.speed = newspeed;

  //Notify all callbacks of the new game speed
  for (var i = 0; i < Reflex.EventCallbacks.gameSpeedChanged.length; i++) {
    Reflex.EventCallbacks.gameSpeedChanged[i](systemData.timeScaler);
  }
};

Reflex.registerEventHandler = function (event, callback) {
  if (typeof Reflex.EventCallbacks[event] === "undefined") {
    console.log("Unknown event handler (" + event + ")");
    return;
  }

  // If event is not already registered, add it
  var index = Reflex.EventCallbacks[event].indexOf(callback);
  if (index === -1) {
    Reflex.EventCallbacks[event].push(callback);
  }
};

Reflex.deregisterEventHandler = function (event, callback) {
  if (typeof Reflex.EventCallbacks[event] === "undefined") {
    console.log("Unknown event handler (" + event + ")");
    return;
  }

  var index = Reflex.EventCallbacks[event].indexOf(callback);
  if (index !== -1) {
    Reflex.EventCallbacks[event].splice(index, 1);
  }
};

Reflex.onReady = function () {
  messageBus.subscribe("common:ReadyToStart", function () {
    if (Reflex.devicePerformance.game.frames === 0) {
      Reflex.devicePerformance.measuringGame = true;
    }
  });

  messageBus.subscribe("common:NetworkError", function (task) {
    var message = task.data.reason;
    if (task.data.showHeaders) {
      message =
        "There has been a network error\n\n" +
        task.data.reason +
        "\n\nPlease close and restart";
    }
    systemOverlay.show(message, task.data.closeButton);
  });
  messageBus.subscribe("languageChanged", Reflex.onLanguageChanged);

  // Initialise all managers
  for (var i = 0; i < Reflex.ManagersInitialiseCallbacks.length; i++) {
    Reflex.ManagersInitialiseCallbacks[i]();
  }

  // Tell everyone we are ready
  for (var i = 0; i < Reflex.EventCallbacks.ready.length; i++) {
    Reflex.EventCallbacks.ready[i]();
  }

  if (Reflex.showPerformance) {
    Reflex.stats = [];
    for (var i = 0; i < 2; ++i) {
      Reflex.stats.push(new Stats());
      Reflex.stats[i].setMode(i); // 0: fps, 1: ms, 2: mb, 3+: custom
      Reflex.stats[i].domElement.style.position = "absolute";
      Reflex.stats[i].domElement.style.left = "" + i * 100 + "px";
      Reflex.stats[i].domElement.style.top = "0px";
      document.body.appendChild(Reflex.stats[i].domElement);
    }
    Reflex.stats.push(new MemoryStats());

    Reflex.stats[2].domElement.style.position = "absolute";
    Reflex.stats[2].domElement.style.left = "200px";
    Reflex.stats[2].domElement.style.top = "0px";
    document.body.appendChild(Reflex.stats[2].domElement);
    Reflex.stats[2].begin = Reflex.stats[2].update;
    Reflex.stats[2].end = function () {};
  }

  // Set up apple resize
  systemData.checkSizeInterval = 200;
  if (
    resourceManager.getConfiguration().system &&
    resourceManager.getConfiguration().system.checkSizeInterval
  ) {
    systemData.checkSizeInterval =
      resourceManager.getConfiguration().system.checkSizeInterval;
  }
  systemData.timeUntilOnResize = 0;

  messageBus.post("languageChanged", gdk.getCurrentLanguage());
  gdk.finishedLoading();
  //Reflex.doSingleRender();
};

Reflex.getIsFullScreen = function () {
  return gdk.isFullscreen();
};

Reflex.onChangeFullScreen = function (isFullScreen) {
  systemData.isFullScreen = isFullScreen;

  if (systemData.isFullScreen) {
    // We just went into full screen, so we know we can do it again
    systemData.canFullScreen = true;
  }

  // Call full screen handlers
  for (var i = 0; i < Reflex.EventCallbacks.fullScreen.length; i++) {
    Reflex.EventCallbacks.fullScreen[i](isFullScreen);
  }

  // As we have changed full screen mode, update layout
  systemData.timeUntilOnResize = systemData.checkSizeInterval;
  Reflex.onResize();
};

Reflex.onOrientationChange = function (isLandscape) {
  //console.log("Changed orientation to " + (isLandscape ? "landscale" : "portrait"));

  for (var i = 0; i < Reflex.EventCallbacks.orientationChange.length; i++) {
    Reflex.EventCallbacks.orientationChange[i](isLandscape);
  }

  // Orientation change calls can take some time, so we reset time after completing
  Reflex.syncTimeRequired = true;
};

Reflex.onNetworkError = function () {};

Reflex.onResize = function () {
  // Because the player can press F11, or click view, full screen, and because this doesnt fire a fullscreen event, we have to manually check here
  var isFullscreen =
    window.innerWidth - screen.width === 0 &&
    window.innerHeight - screen.height === 0;
  if (isFullscreen !== systemData.isFullScreen) {
    // Tell system we changed to fullscreen
    Reflex.onChangeFullScreen(isFullscreen);
  }

  // Check the sizes of the window. Only do a resize if they have changed.
  // Note: This allows us to call this function constantly to deal with apple not changing the window sizes until they feel like it
  var size = gdk.getWindowSize();
  if (
    systemData.PHYSICAL_SCREEN_WIDTH === size.width &&
    systemData.PHYSICAL_SCREEN_HEIGHT === size.height
  ) {
    // Sizes have not changed, so nothing else to do here
    return;
  }

  // As sized have changed, update the viewport
  Reflex.updateViewport();
};

Reflex.updateViewport = function () {
  var size = gdk.getWindowSize();

  // Get width and height (clientWidth/clientHeight is for IE8 and below)
  systemData.PHYSICAL_SCREEN_WIDTH = size.width;
  systemData.PHYSICAL_SCREEN_HEIGHT = size.height;

  var physicalScreenWidth = systemData.PHYSICAL_SCREEN_WIDTH;
  var physicalScreenHeight = systemData.PHYSICAL_SCREEN_HEIGHT;

  var selectedScaleX;
  var selectedScaleY;
  var offsetX = 0;
  var offsetY = 0;

  // Landscape / portrait layout change?
  if (
    systemData.PHYSICAL_SCREEN_WIDTH < systemData.PHYSICAL_SCREEN_HEIGHT &&
    systemData.isLandscape
  ) {
    // Changed to portrait
    systemData.isLandscape = false;
    Reflex.onOrientationChange(false);
  }

  if (
    systemData.PHYSICAL_SCREEN_WIDTH >= systemData.PHYSICAL_SCREEN_HEIGHT &&
    !systemData.isLandscape
  ) {
    // Changed to landscape
    systemData.isLandscape = true;
    Reflex.onOrientationChange(true);
  }

  Reflex.logicalScreenWidth = systemData.LOGICAL_SCREEN_WIDTH;
  Reflex.logicalScreenHeight = systemData.LOGICAL_SCREEN_HEIGHT;

  Reflex.scaleX = physicalScreenWidth / Reflex.logicalScreenWidth;
  Reflex.scaleY = physicalScreenHeight / Reflex.logicalScreenHeight;

  if (typeof systemData.renderer === "undefined") {
    // System is still starting
    return;
  }

  // This causes flicker in IE11 but we need it for canvas size
  systemData.renderer.resize(physicalScreenWidth, physicalScreenHeight);

  for (var name in resourceManager.containers) {
    var data = Reflex.getContainerPosition(name);
    resourceManager.containers[name].scale.set(
      data.scale.x * resourceManager.selectedAssetResolution.scaleFactor,
      data.scale.y * resourceManager.selectedAssetResolution.scaleFactor
    );
    resourceManager.containers[name].position.set(
      data.position.x,
      data.position.y
    );
  }

  // If we are paused, redraw screen
  if (Reflex.gamePaused || Reflex.platformPaused) {
    systemData.renderer.render(systemData.stage);
  }

  var platformData = gdk.getPlatformScreenData();
  var gameContainerWidth =
    physicalScreenWidth -
    platformData.screenData.borderLeft -
    platformData.screenData.borderRight;
  var gameContainerHeight =
    physicalScreenHeight -
    platformData.screenData.borderTop -
    platformData.screenData.borderBottom;
  systemData.gameContainer.scale.set(
    Math.max(0, gameContainerWidth / physicalScreenWidth),
    Math.max(0, gameContainerHeight / physicalScreenHeight)
  );
  systemData.gameContainer.position.set(
    platformData.screenData.borderLeft,
    platformData.screenData.borderTop
  );

  // Let everyone know we have resized
  for (var i = 0; i < Reflex.EventCallbacks.resize.length; i++) {
    Reflex.EventCallbacks.resize[i](
      systemData.PHYSICAL_SCREEN_WIDTH,
      systemData.PHYSICAL_SCREEN_HEIGHT,
      systemData.isLandscape
    );
  }
};

Reflex.getContainerPosition = function (name) {
  var position = {};
  var scale = {};

  switch (resourceManager.containers[name].Props.scaleMode) {
    default:
    case "fit":
      {
        // This scales the container to fit inside the screen (may leave black bars if it doesnt fit, but keeps 1:1)
        if (Reflex.scaleX < Reflex.scaleY) {
          selectedScaleX = Reflex.scaleX;
          selectedScaleY = Reflex.scaleX;
          offsetX = 0;
          offsetY =
            (gdk.getScreenHeight() -
              Reflex.logicalScreenHeight * Reflex.scaleX) /
            2;
        } else {
          selectedScaleX = Reflex.scaleY;
          selectedScaleY = Reflex.scaleY;
          offsetX =
            (gdk.getScreenWidth() - Reflex.logicalScreenWidth * Reflex.scaleY) /
            2;
          offsetY = 0;
        }
      }
      break;

    case "fill":
      {
        // This scales the container to fit inside the screen (may clip some of the image if it doesnt fit, but keeps 1:1)
        var fillWidth = resourceManager.containers[name].Props.fillWidth;
        var fillHeight = resourceManager.containers[name].Props.fillHeight;
        if (typeof fillWidth === "undefined") {
          console.error("Fill width for " + name + " has not been defined");
        }

        if (typeof fillHeight === "undefined") {
          console.error("Fill height for " + name + " has not been defined");
        }

        var len = Math.max(gdk.getScreenWidth(), gdk.getScreenHeight());
        selectedScaleX = len / fillWidth;
        selectedScaleY = len / fillHeight;

        offsetX =
          -(Math.floor(selectedScaleX * fillWidth) - gdk.getScreenWidth()) / 2;
        offsetY =
          -(Math.floor(selectedScaleY * fillHeight) - gdk.getScreenHeight()) /
          2;
      }
      break;

    case "stretch":
      {
        // This scales the container to fit exactly on screen (no clipping or bars, but may not be 1:1)
        // This scales the container to fit inside the screen (may clip some of the image if it doesnt fit, but keeps 1:1)
        var fillWidth = resourceManager.containers[name].Props.fillWidth;
        var fillHeight = resourceManager.containers[name].Props.fillHeight;
        if (typeof fillWidth === "undefined") {
          console.error("Fill width for " + name + " has not been defined");
        }

        if (typeof fillHeight === "undefined") {
          console.error("Fill height for " + name + " has not been defined");
        }

        selectedScaleX = gdk.getScreenWidth() / fillWidth;
        selectedScaleY = gdk.getScreenHeight() / fillHeight;

        offsetX =
          -(Math.floor(selectedScaleX * fillWidth) - gdk.getScreenWidth()) / 2;
        offsetY =
          -(Math.floor(selectedScaleY * fillHeight) - gdk.getScreenHeight()) /
          2;
      }
      break;

    case "none":
      {
        selectedScaleX = 1;
        selectedScaleY = 1;

        offsetX = 0;
        gdk.getScreenWidth() / 2;
        offsetY = 0;
      }
      break;
  }
  scale.x = selectedScaleX;
  scale.y = selectedScaleY;
  switch (resourceManager.containers[name].Props.alignmentX) {
    default:
    case "left":
      position.x = 0;
      break;
    case "center":
      position.x = offsetX;
      break;
    case "right":
      position.x = offsetX * 2;
      break;
  }
  switch (resourceManager.containers[name].Props.alignmentY) {
    default:
    case "top":
      position.y = 0;
      break;
    case "center":
      position.y = offsetY;
      break;
    case "bottom":
      position.y = offsetY * 2;
      break;
  }

  return { position: position, scale: scale };
};

Reflex.addToUpdate = function (updateFunction) {
  Reflex.updateFunctions.push(updateFunction);
};

Reflex.removeFromUpdate = function (updateFunction) {
  var index = Reflex.updateFunctions.indexOf(updateFunction);
  if (index !== -1) {
    Reflex.updateFunctions.splice(index, 1);
  }
};

Reflex.doSingleRender = function () {
  Reflex.singleRender = true;
};

// Main game loop. Called once game has loaded
Reflex.gameLoop = function (currentTime, delta) {
  // -------------------------
  // Main Game Loop
  // -------------------------

  // - Do not put logic in this loop.
  // - Only call into other functions e.g. updates
  // - Keep it simple, keep it clean

  // Measure performance at the start of the game (take 0.5 seconds)
  if (resourceManager.isLoaded) {
    if (Reflex.devicePerformance.measuringCapability) {
      // Removed - to be reintroduced at a later date
      Reflex.devicePerformance.measuringCapability = false;
      Reflex.devicePerformance.measuringGame = false;
      Reflex.devicePerformance.capability.frames = 60;
      Reflex.devicePerformance.capability.time = 1;
      Reflex.devicePerformance.game.frames = 60;
      Reflex.devicePerformance.game.time = 1;
      Reflex.calculateDevicePerformance(true);
      Reflex.calculateDevicePerformance(false);

      for (var i = 0; i < Reflex.EventCallbacks.devicePerformance.length; i++) {
        Reflex.EventCallbacks.devicePerformance[i](
          Reflex.devicePerformance.capability.value,
          Reflex.devicePerformance.game.value
        );
      }
    }
  }

  // Check for window resizes (to cope with Apple not changing reported window sizes until some time after a resize)
  if (systemData.timeUntilOnResize > 0) {
    systemData.timeUntilOnResize -= delta;
    if (systemData.timeUntilOnResize <= 0) {
      systemData.timeUntilOnResize = systemData.checkSizeInterval;
      Reflex.onResize();
    }
  }

  if (Reflex.gamePaused || Reflex.platformPaused) {
    return;
  }

  systemData.unscaledDelta = delta;

  if (Reflex.developerMode) {
    delta *= Reflex.developerModeData.speedModifier;
  }

  //Apply the time scaler
  delta *= systemData.timeScaler;

  // Store game time
  systemData.gameTime += delta;

  //if (update) console.clear();
  for (var i = Reflex.updateFunctions.length - 1; i >= 0; i--) {
    if (Reflex.performance.updateRequired) {
      // Measured function call
      var startTime = new Date().getTime();
      Reflex.updateFunctions[i](delta, systemData.gameTime);
      var totalTime = new Date().getTime() - startTime;
      console.log(i + " = " + totalTime);
    } else {
      // Non measured function call
      Reflex.updateFunctions[i](delta, systemData.gameTime);
    }
  }
};

// Animation callback function
Reflex.animate = function (time) {
  if (Reflex.syncTimeRequired) {
    systemData.lastUpdateTime = time;
    Reflex.syncTimeRequired = false;
  }

  if (Reflex.performance.showPerformanceStats) {
    Reflex.performance.updateRequired = false;
    Reflex.performance.updateTime -= time - systemData.lastUpdateTime;
    if (Reflex.performance.updateTime <= 0) {
      Reflex.performance.updateTime = 1000;
      Reflex.performance.updateRequired = true;
    }
  }

  if (Reflex.performance.updateRequired) {
    console.clear();
    Reflex.performance.startTime = new Date().getTime();
  }

  if (layoutController.updateRequired) {
    layoutController.updateLayout();
  }

  if (Reflex.showPerformance && Reflex.stats) {
    for (var i = 0; i < Reflex.stats.length; ++i) Reflex.stats[i].begin();
  }

  if (
    resourceManager.isLoaded &&
    !Reflex.gamePaused &&
    !Reflex.platformPaused
  ) {
    Reflex.gameLoop(time, time - systemData.lastUpdateTime);
  }

  if ((!Reflex.gamePaused && !Reflex.platformPaused) || Reflex.singleRender) {
    Reflex.singleRender = false;
    systemData.renderer.render(systemData.stage);
  }

  requestAnimationFrame(Reflex.animate);
  systemData.lastUpdateTime = time;

  if (Reflex.showPerformance && Reflex.stats) {
    for (var i = 0; i < Reflex.stats.length; ++i) Reflex.stats[i].end();
  }

  if (Reflex.performance.updateRequired) {
    var totalTime = new Date().getTime() - Reflex.performance.startTime;
    console.log("total time is " + totalTime + "ms");
  }
};

Reflex.createRenderer = function () {
  var renderOptions = {
    antialias: Reflex.antiAlias,
    transparent: true,
    resolution: gdk.deviceInfo.devicePixelRatio,
    autoResize: true,
    view: document.getElementById("game-canvas") || undefined,
  };

  let canvasContainer = document.getElementsByClassName("canvasContainer");
  if (canvasContainer.length > 0) {
    canvasContainer = canvasContainer[0];
  } else {
    canvasContainer = null;
  }

  let parentContainer = canvasContainer || document.body;

  if (Reflex.rendererCreated) {
    if (renderOptions.view === undefined)
      parentContainer.removeChild(systemData.renderer.view);
    systemData.renderer.destroy(true);
  }

  // use canvas only instead of webGL on LG G3 because the LGG3 wrecks corrupts when using masks
  var forceCanvasOverride = navigator.userAgent.indexOf("; LG-D") !== -1;

  // Create renderer
  if (Reflex.developerModeData.forceCanvasRenderer || forceCanvasOverride) {
    // Developer wants us to force a canvas renderer, or we need to force canvas as phone doesnt support webGL 2
    renderOptions.width = 1;
    renderOptions.height = 1;
    systemData.renderer = new PIXI.CanvasRenderer(renderOptions);
  } else {
    systemData.renderer = PIXI.autoDetectRenderer(1, 1, renderOptions);
  }

  if (renderOptions.view === undefined) {
    if (canvasContainer) {
      systemData.renderer.view.className = "gameCanvas";
    }
    parentContainer.appendChild(systemData.renderer.view);
  }

  systemData.rendererOriginalResolution = systemData.renderer.resolution;

  if (Reflex.rendererCreated) {
    // We just deleted and recreated the renderer, so send an event out
    for (
      var i = Reflex.EventCallbacks.rendererChanged.length - 1;
      i >= 0;
      i--
    ) {
      Reflex.EventCallbacks.rendererChanged(systemData.renderer);
    }
  }

  Reflex.rendererCreated = true;
};

Reflex.initialise = function (gameLoader) {
  // Disable pinch zooming (apple disabled user-scalable=no after iOS10)
  document.addEventListener("gesturestart", function (e) {
    e.preventDefault();
  });

  var configMessage = gdk.peekNextMessage();
  if (configMessage !== undefined) {
    resourceManager.configValues.showHomeButton = checkForDefined(
      configMessage.showHomeButton
    )
      ? configMessage.showHomeButton
      : false;
    resourceManager.configValues.paylines = checkForDefined(
      configMessage.paylines
    )
      ? configMessage.slotConfig.paylines.length
      : 0;
  }

  // Create PIXI
  systemData.stage = new PIXI.Container();
  Reflex.createRenderer();

  gdk.onFullscreenChange(function () {
    Reflex.onChangeFullScreen(Reflex.getIsFullScreen());
  });

  // The game container holds everything that is loaded for the game
  systemData.gameContainer = new PIXI.Container();
  systemData.stage.addChild(systemData.gameContainer);

  // This is for showing a recovery screen while the game recovers in the background
  systemData.recoveryContainer = new PIXI.Container();
  systemData.recoveryContainer.visible = false;
  systemData.stage.addChild(systemData.recoveryContainer);

  // The overlay controller is used for anything that HAS to go on top of the game. i.e. System overlays or console.
  systemData.overlayContainer = new PIXI.Container();
  systemData.stage.addChild(systemData.overlayContainer);

  // Create console (if included)
  if (typeof DevConsole !== "undefined") {
    DevConsole.initialise(systemData.overlayContainer);
  }

  // Initialise system overlay
  systemOverlay.initialise(systemData.overlayContainer);

  // Initialise html viewer
  htmlViewer.initialise(systemData.overlayContainer);

  // Set up initial screen scaling
  Reflex.onResize();

  // Initialises this games loader, so it's prepared to load
  gameLoader.initialise(systemData.gameContainer);

  // Resource Manager handles all loading, so start the loading process
  resourceManager.initialise();
};

Reflex.registerInitialiseManager = function (initialiseFunction) {
  Reflex.ManagersInitialiseCallbacks.push(initialiseFunction);
};

Reflex.onRealityCheckStart = function () {
  if (Reflex.getIsFullScreen() && checkForDefined(gdk.deviceInfo.android)) {
    // We were in full screen on an android device, so exit full screen
    gdk.exitFullscreen();
  }
};

Reflex.onRealityCheckEnd = function () {};

Reflex.onWindowResize = function () {
  systemData.timeUntilOnResize = systemData.checkSizeInterval;
  Reflex.onResize();
};

// Set up event handlers
gdk.onWindowResize(Reflex.onWindowResize);
gdk.onKeydown(Reflex.onKeyDown);
gdk.onKeyup(Reflex.onKeyUp);
gdk.onFocus(Reflex.onFocus);
gdk.onBlur(Reflex.onBlur);

// Here we reassign the pixi renderer function. This is a work around for wide text not showing
// See http://www.html5gamedevs.com/topic/28348-text-object-shows-as-black-box-for-long-strings/#comment-163239
Object.assign(PIXI.Text.prototype, {
  renderWebGL: function (renderer) {
    this.updateText(true);

    if (this.visible) {
      PIXI.Sprite.prototype.renderWebGL.call(this, renderer);
    }
  },
  renderCanvas: function (renderer) {
    this.updateText(true);

    if (this.visible) {
      PIXI.Sprite.prototype._renderCanvas.call(this, renderer);
    }
  },
});

PIXI.Sprite.prototype.getHeight = function () {
  return this.height / resourceManager.selectedAssetResolution.scaleFactor;
};

PIXI.Sprite.prototype.getWidth = function () {
  return this.width / resourceManager.selectedAssetResolution.scaleFactor;
};

PIXI.Sprite.prototype.setHeight = function (height) {
  this.height = height * resourceManager.selectedAssetResolution.scaleFactor;
};

PIXI.Sprite.prototype.setWidth = function (width) {
  this.width = width * resourceManager.selectedAssetResolution.scaleFactor;
};
